import axios from "axios";
import Swal from "sweetalert2";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8800/api";

export const makeRequest = axios.create({
  baseURL: BASE_URL,
  withCredentials: true, 
});

makeRequest.interceptors.request.use(
  (config) => {
    try {
      const userString = localStorage.getItem("user");
      if (userString) {
        const user = JSON.parse(userString);
        if (user.csrfToken) {
          config.headers['x-xsrf-token'] = user.csrfToken;
        }
        if (user.accessToken) {
          config.headers['Authorization'] = `Bearer ${user.accessToken}`;
        }
      }
    } catch (error) {
      console.error("Error parsing user from localStorage", error);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

makeRequest.interceptors.response.use(
  (response) => {
    return response;
  },

  (error) => {
    if (error.response && error.response.status === 403) {
      if (error.response.data?.isBanned || error.response.data === "Your account has been locked by the Admin!") {
        localStorage.removeItem("user");
        localStorage.removeItem("myPrivateKey"); 
        localStorage.removeItem("myPublicKey");

        Swal.fire({
          icon: 'error',
          title: 'Account Locked!',
          text: 'Your login session has ended because your account has been locked by the Admin.',
          confirmButtonText: 'Understood',
          confirmButtonColor: '#938eef',
          background: '#fff',
          allowOutsideClick: false 
        }).then(() => {
          window.location.href = "/login";
        });
      }

      if (error.response.data?.sessionExpired) {
        localStorage.removeItem("user");
        localStorage.removeItem("myPrivateKey"); 
        localStorage.removeItem("myPublicKey");

        Swal.fire({
          icon: 'warning',
          title: 'Your login session has expired!',
          text: 'Your account is already logged in on a different device or browser. Please log in again.',
          confirmButtonText: 'Log in again',
          confirmButtonColor: '#938eef',
          background: '#fff',
          allowOutsideClick: false 
        }).then(() => {
          window.location.href = "/login";
        });
      }
    }
    return Promise.reject(error);
  }
);

export default makeRequest;